import { useTranslation } from 'react-i18next';

export function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const current = i18n.language.startsWith('de') ? 'de' : 'en';
  return (
    <div className="inline-flex rounded-lg border border-ink-200 bg-white text-xs font-medium overflow-hidden">
      {(['de', 'en'] as const).map((lng) => (
        <button
          key={lng}
          type="button"
          onClick={() => void i18n.changeLanguage(lng)}
          className={`px-2.5 py-1 transition-colors ${
            current === lng ? 'bg-ink-900 text-white' : 'text-ink-600 hover:bg-ink-50'
          }`}
        >
          {lng.toUpperCase()}
        </button>
      ))}
    </div>
  );
}
